export default __webpack_public_path__ + "static/media/icon_medicine.e0d13d99.png";